<template>
  <v-dialog v-model="show" width="500px">
    <v-card>
      <v-card-title class="d-flex" style="position: relative"
                    :class="$vuetify.breakpoint.smAndDown ? 'justify-start' : 'justify-center'">
        <h3>ATTENTION</h3>
        <v-btn icon style="position: absolute; right: 15px; top: 10px;" @click="show=false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>


      <v-divider color="#42a5f5"></v-divider>
      <v-container>
        <v-card-text class="text-center">
          You are about to cancel your delivery.<br> <br>
          Please select a cancellation code and write us a note about the reason of your cancellation.
        </v-card-text>
        <v-row justify="center">
          <v-col cols="12" v-if="isInternalUser">
            <v-select
              v-model="code"
              :items="codes"
              item-text="text"
              item-value="code"
              label="Select a reason..."
            ></v-select>
          </v-col>
          <v-col cols="12">
            <v-textarea
              v-model="note"
              label="Why are you requesting this cancellation?"
            ></v-textarea>
          </v-col>
          <v-col cols="12" v-show="isInternalUser">
            <v-switch
              :disabled="!isInternalUser"
              style="justify-content: center"
              color="blue"
              v-model="overrideCutOff"
              :label="overrideCutOff ? 'Ignore Cut Off' : 'Enforce Cut Off'"
            ></v-switch>
          </v-col>
        </v-row>
        <v-row justify="center" :class="{'flex-column': $vuetify.breakpoint.smAndDown}">
          <v-col md="6" cols="12">
            <v-btn text block color="blue-grey lighten-2" @click="show=false">Back</v-btn>
          </v-col>
          <v-col md="6" cols="12">
            <v-btn text block color="red" @click="cancelDelivery">Confirm cancellation</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
    import axios from 'axios';

    export default {
        name: "DeliveryCancelDialog",
        props: {
            tracking: String,
            showProp: Boolean
        },
        data() {
            return {
                code: null,
                note: null,
                codes: [
                    {code: 'CNX', text: 'Cancelled by Client'},
                    {code: 'OOA', text: 'Out of Area'},
                    {code: 'GNR', text: 'Goods Not Received'},
                    {code: 'MS', text: 'Miss Sort'},
                    {code: 'W', text: 'Withheld'},
                    {code: 'OR', text: 'Other'},
                ],
                overrideCutOff: false,
            }
        },
        computed: {
            show: {
                get() {
                    return this.showProp;
                },
                set(value) {
                    if (!value) this.$emit('close');
                }
            },
            isInternalUser() {
                return this.$store.getters['auth/isInternalUser'];
            }
        },
        methods: {
            cancelDelivery() {
                this.$store.commit('displayWaitDialog', true);
                this.$emit('changeLoading', true);
                let body = {};
                if (this.code !== null) {
                    body = {code: this.code, note: this.note}
                } else {
                    body = {code: 'CNX', note: this.note}
                }
                axios.post(process.env.API_URL + '/deliveries/' + this.tracking + '/cancel', body)
                    .then((response) => {
                        this.$store.commit('displaySnackbar', 'Successfully canceled delivery');
                        this.show = false;
                        this.$store.commit('displayWaitDialog', false);
                        this.$emit('changeLoading', false);
                    })
                    .catch((response) => {
                        this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                        this.$store.commit('displayWaitDialog', false);
                        this.$emit('changeLoading', false);
                    });
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Delivery/Search/DeliveryCancelDialog.vue